import React, { useState } from 'react'
import { Button, Col, Container, Form, Row, ToastContainer } from 'react-bootstrap'
import { MailRequest } from '../models/mailRequest';
import axios from 'axios';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export function Contactus() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const baseUrl = process.env.REACT_APP_API_URL + 'mail/send';

    function handleSubmit() {
        const request = {} as MailRequest

        request.name = name;
        request.to = 'support@englishedit.ai';
        request.subject = subject;
        request.content = message;
        request.from = email;

        var response = axios.post(baseUrl!, request).then(response => {
            handleOutput();
        });
    }

    function handleOutput() {
        setIsSuccess(true);
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
    }

    return (
        <>
            <Container>
                <HelmetProvider>
                    <Helmet>
                        <title>EnglishEditAI - Contact Us</title>
                        <meta name="description" content="Need help? We are just a click away."></meta>
                    </Helmet>
                </HelmetProvider>
                <Row>
                    <Col></Col>
                    <Col style={{ textAlign: "center" }}>
                        <h1>Contact us</h1>
                    </Col>
                    <Col></Col>
                </Row>
                <Row style={{ marginTop: "2em" }}>
                    <Col lg={1}></Col>
                    <Col lg={11}><h5 style={{ textAlign: "center" }}>We want to know how our free writing tool worked for you. What do you like about it? What can we improve? Your feedback will help us to better help more writers like yourself with our free service.</h5></Col>
                    <Col></Col>
                </Row>

                <Row className='mb-3' style={{ marginTop: '2em' }}>
                    <Col></Col>
                    <Col>
                        <Form.Group className='mb-3' controlId="formBasicEmail">

                            <Form.Control value={name} onChange={(e) => setName(e.target.value)} className='mb-4' type="name" placeholder="Enter name" />

                            <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} className='mb-4' type="email" placeholder="Enter email" />

                            <Form.Control value={subject} onChange={(e) => setSubject(e.target.value)} className='mb-4' type="subject" placeholder="Enter subject" />

                            <Form.Control value={message} onChange={(e) => setMessage(e.target.value)} className='mb-4' as='textarea' rows={10} placeholder="Enter a message" />

                        </Form.Group>
                        <Form.Group style={{ textAlign: 'center' }}>
                            <Button onClick={handleSubmit} variant="success">
                                Submit
                            </Button>
                        </Form.Group>
                        {isSuccess ? <span style={{ fontSize: '30px', color: 'black', fontWeight: 500 }}>Thank you for contacting us.</span> : false}
                    </Col>
                    <Col>
                    </Col>
                </Row>

            </Container>

        </>
    )
}